import { render, staticRenderFns } from "./SubscriptionsForm.vue?vue&type=template&id=1a159563&scoped=true&"
import script from "./SubscriptionsForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a159563",
  null
  
)

export default component.exports